import { useAuth } from '../lib/auth'
import { usePreviewRole } from './usePreviewRole'

// Every permission check in the app reads from this hook. It returns the
// EFFECTIVE role — which may be a preview role set by a super_admin via the
// role switcher in the top bar, or the user's actual role otherwise.
//
// The real-role fields (realRole, realIsSuperAdmin) are exposed so the
// switcher itself — and anything else that must respect the user's *actual*
// privilege — can check past the preview.
export function useRole() {
  const { profile } = useAuth()
  const { previewRole } = usePreviewRole()

  const realRole = profile?.role || 'member'
  // Only an actual super_admin may preview another role.
  const role = (realRole === 'super_admin' && previewRole) ? previewRole : realRole

  return {
    role,
    realRole,
    isPreviewing: role !== realRole,
    isSuperAdmin: role === 'super_admin',
    isAdmin: role === 'admin' || role === 'super_admin',
    isMember: role === 'member',
    isFoster: role === 'foster',
    isAdopter: role === 'adopter',
    // Anything that is NOT a foster or an adopter — convenience for
    // guarding routes/components that only staff can see.
    isStaff: role === 'admin' || role === 'super_admin' || role === 'member',
    // The real-user guards — use these for the switcher UI itself.
    realIsSuperAdmin: realRole === 'super_admin',
  }
}
